import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormGroup, UntypedFormBuilder} from '@angular/forms';
import {InterviewDataService} from './services/interview-data.service';
import {BackendService} from '../../common/services/backend.service';

@Component({
    selector: 'share-interview',
    template: `
    <div class="modal-header">
      <h4 class="modal-title">{{'interviews.Share Interview' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="alert success" role="alert" aria-live="polite" *ngIf="toastMessage">{{toastMessage | translate}}</div>
        <p class="space-bottom-xs">{{'interviews.Share Interview Instructions' | translate}}</p>
        <div class="share-link-container">
            <div class="share_link">
                <span class="share-link-url">{{shareLink}}</span>
            </div>
            <button type="button" class="btn btn_default share-link-copy-btn" (click)="copyLink()" attr.aria-label="{{'interviews.Link Copied' | translate}}">
                <i class="icn icn-copy icon-size-sm no-margin" aria-hidden="true"></i>
            </button>
        </div>
        <form [formGroup]="form" (ngSubmit)="savePasscode()">
            <div class="field">
                <div class="field-widget">
                    <label for="passcode">{{'interviews.Set Passcode' | translate}}</label>
                    <p class="field-blurb" id="passcode-blurb">{{'interviews.Passcode Blurb' | translate}}</p>
                    <input type="text" class="input-text" formControlName="passcode" id="passcode" aria-describedby="passcode-blurb" />
                </div>
            </div>
            <div class="field">
                <div class="field-widget input-checkbox-widget">
                    <input type="checkbox" class="input-checkbox" id="passcode-agree"
                           formControlName="globalPasscode" (click)="checkValue()">
                    <label class="form-check-label" for="passcode-agree">{{'interviews.Use Passcode' | translate}}</label>
                </div>
            </div>
            <button type="submit" class="btn btn_default">{{'interviews.Save Passcode' | translate}}</button>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn_default" (click)="activeModal.close()">{{'interviews.Close' | translate}}</button>
    </div>
  `,
    standalone: false
})
export class ShareInterviewComponent implements OnInit {

    form: UntypedFormGroup;
    isChecked: boolean = false;
    shareLink: string;
    toastMessage: string = '';

    @Output() interviewShared: EventEmitter<any> = new EventEmitter<any>();

    constructor(public activeModal: NgbActiveModal,
                private fb: UntypedFormBuilder,
                private _backendService: BackendService,
                private _dataService: InterviewDataService) {
    }

    ngOnInit() {
        this.createForm();
        this.getShortlink();
        this.populateForm();
    }

    createForm() {
        this.form = this.fb.group({
            passcode: [''],
            globalPasscode: ['']
        });
    }

    checkValue() {
        this.isChecked = !this.isChecked;
        this.form.controls['globalPasscode'].setValue(this.isChecked);
    }

    copyLink() {
        navigator.clipboard.writeText(this.shareLink);
        this.toastMessage = 'interviews.Link Copied';
    }

    savePasscode() {
        let data = <any>{};
        data.passcode = this.form.controls['passcode'].value;
        data.globalPasscode = (this.form.controls['globalPasscode'].value) ? '1' : '0';
        this.interviewShared.emit(data);
        this.toastMessage = 'interviews.Passcode Saved';
    }

    populateForm() {
        this._dataService.getPasscode();
        this._dataService.passcode.subscribe((val: any) => {
            if (val) {
                this.form.controls['passcode'].setValue(val.passcode);
                this.isChecked = (val.global_passcode !== undefined && val.global_passcode !== '0');
                this.form.controls['globalPasscode'].setValue(this.isChecked);
            }
        });
    }

    getShortlink() {
        let url = 'video-interview-attempt/' + this._dataService.attemptId + '/shortlink';
        this._backendService.getShortlink('', url)
            .subscribe((resp: string) => {
                if (resp)
                    this.shareLink = resp;
        });
    }

}
